import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { CHART_RED, CHART_ORANGE, CHART_GREEN } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import UIImage from 'UIComponents/image/UIImage';
import { getActiveExperimentsParameters } from '../experiments/ExperimentUtils';
import { useFeedbackWidget } from '../hooks/useFeedback';
import imageUrls from '../images/imageUrls';
import { useTracker } from '../tracking/useTracker';
import { FeedbackContainer, FeedbackHeader, FeedbackTileSection, Rating, RatingIcon } from './feedback.styles';
import { ThankYouScreen } from './ThankYouScreen';
export let FeedBackOption;

(function (FeedBackOption) {
  FeedBackOption["negative"] = "negative";
  FeedBackOption["neutral"] = "neutral";
  FeedBackOption["positive"] = "positive";
})(FeedBackOption || (FeedBackOption = {}));

export const FeedbackWidget = () => {
  const tracker = useTracker();
  const shouldUseFeedbackWidget = useFeedbackWidget();
  const [showThankYou, shouldShowThankYou] = useState(false);
  const [displayFeedbackWidget, shouldDisplayFeedbackWidget] = useState(true);
  const experimentParameters = useSelector(getActiveExperimentsParameters);

  const onClickRating = option => {
    tracker.signupInteraction('submit-feedback-rating', {
      selectedOption: option,
      experimentParameter: experimentParameters
    });
    shouldShowThankYou(true);
  };

  if (!shouldUseFeedbackWidget || !displayFeedbackWidget) {
    return null;
  }

  if (showThankYou) {
    return /*#__PURE__*/_jsx(ThankYouScreen, {
      shouldDisplayFeedbackWidget: shouldDisplayFeedbackWidget
    });
  }

  return /*#__PURE__*/_jsxs(FeedbackContainer, {
    closeable: true,
    id: "feedback-widget-container",
    maxWidth: "330px",
    onClose: () => {
      shouldDisplayFeedbackWidget(false);
    },
    children: [/*#__PURE__*/_jsx(FeedbackHeader, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'feedbackWidget.title'
      })
    }), /*#__PURE__*/_jsxs(FeedbackTileSection, {
      children: [/*#__PURE__*/_jsx(Rating, {
        className: "m-y-4",
        onClick: () => {
          onClickRating(FeedBackOption.negative);
        },
        children: /*#__PURE__*/_jsx(RatingIcon, {
          color: CHART_RED,
          children: /*#__PURE__*/_jsx(UIImage, {
            src: imageUrls.negative
          })
        })
      }), /*#__PURE__*/_jsx(Rating, {
        className: "m-y-4",
        onClick: () => {
          onClickRating(FeedBackOption.neutral);
        },
        children: /*#__PURE__*/_jsx(RatingIcon, {
          color: CHART_ORANGE,
          children: /*#__PURE__*/_jsx(UIImage, {
            src: imageUrls.neutral
          })
        })
      }), /*#__PURE__*/_jsx(Rating, {
        className: "m-y-4",
        onClick: () => {
          onClickRating(FeedBackOption.positive);
        },
        children: /*#__PURE__*/_jsx(RatingIcon, {
          color: CHART_GREEN,
          children: /*#__PURE__*/_jsx(UIImage, {
            src: imageUrls.happy
          })
        })
      })]
    })]
  });
};